import { useEffect, useState } from "react";
import { Fund } from "~/models/fund";
import { getFund } from "~/common/api/list";

/**
 * hook to fetch a fund whenever the listId or randomize changes
 *
 * @param listId - string representing list id
 * @param randomize - boolean representing whether to randomize the list
 * @returns - an array containing the fund of nonprofits
 */
export const useFund = (
  listId: string | undefined | null,
  showFundDetails: boolean,
  randomize: boolean,
): [Fund[] | undefined, boolean] => {
  const [list, setList] = useState<Fund[]>();
  const [isError, setIsError] = useState<boolean>(false);

  useEffect(() => {
    async function fetchFund(
      fundId: string | undefined | null,
      showFundDetails: boolean,
      randomize: boolean,
    ) {
      setList(undefined);

      if (fundId && showFundDetails) {
        const results = await getFund(Number(fundId), randomize).catch(
          (error) => {
            console.error("FundView: Error fetching nonprofits", error);
            setIsError(true);
          },
        );

        // console.log("results", results);
        setList(results || []);
      }
    }

    fetchFund(listId, showFundDetails, randomize);
  }, [listId, showFundDetails, randomize]);

  return [list, isError];
};
